import Widget from "@/components/widgets";
import type { WidgetConfig } from "@/types";
import { MasonryWallOfLovePageComponentWidget } from "@/features/wall-of-love/masonry-wall";

declare global {
  interface Window {
    MasonryWallOfLoveWidget: typeof MasonryWallOfLoveWidget;
  }
}

class MasonryWallOfLoveWidget extends Widget {
  static init(config: WidgetConfig) {
    return super.init(config, MasonryWallOfLovePageComponentWidget);
  }
}

if (typeof window !== "undefined") {
  window.MasonryWallOfLoveWidget = MasonryWallOfLoveWidget;
}

export default MasonryWallOfLoveWidget;
